import { useMemo, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import FJMultiSourceDownloadButton from './FJMultiSourceDownloadButton.jsx';
import FJActionCommon from '../../../redux/action/FJActionCommon.js';
import FJAIToolUtil from '../../../util/FJAIToolUtil.js';
import FJConstant from '../../../constants/FJConstant.js';

const FJMultiSourceDownloadButtonContainer = () => {
    const dispatch = useDispatch();
    const isCanDownload = useSelector(state => state.textToImage.isDone);
    const headerTabIndex = useSelector(state => state.common.headerTabIndex);
    const taskStatus = useSelector(state => state.textToImage.taskStatus);
    const list = useSelector(state => state.textToImage.creationList);
    const selectedDownloadList = useSelector(state => state.common.selectedDownloadList);
    const batchDownloadLoading = useSelector(state => state.common.batchDownloadLoading);
    const appType = useSelector(state => state.common.appType);

    const _list = useMemo(() => {
        const isVideo = FJAIToolUtil.getVideoAppTypeList().includes(appType);
        return list.map(item => {
            const { id, imgUrl, originalUrl, width, height, videoUrl } = item;
            return {
                id,
                width,
                height,
                url: isVideo ? videoUrl : imgUrl || originalUrl,
            };
        });
    }, [list, appType]);

    const _selectAll = useCallback(() => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([...list]));
    }, [dispatch, list]);

    const _deselectAll = useCallback(() => {
        dispatch(FJActionCommon.setSelectedDownloadItemsAction([]));
    }, [dispatch]);

    const _selectItem = useCallback(
        (id, selected) => {
            if (selected) {
                const item = list.find(item => item.id === id);
                if (selectedDownloadList.indexOf(item) === -1) {
                    const newList = [...selectedDownloadList];
                    newList.push(item);
                    dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
                }
            } else {
                const index = selectedDownloadList.findIndex(item => item.id === id);
                if (index !== -1) {
                    const newList = selectedDownloadList.filter(item => item.id !== id);
                    dispatch(FJActionCommon.setSelectedDownloadItemsAction(newList));
                }
            }
        },
        [dispatch, list, selectedDownloadList],
    );

    const _download = useCallback(() => {
        dispatch(FJActionCommon.downloadSelectedItemsAction(list));
    }, [dispatch, list]);

    if (taskStatus === FJConstant.ERROR || headerTabIndex !== FJConstant.CREATIONS || !isCanDownload) {
        return null;
    }

    return (
        <FJMultiSourceDownloadButton
            list={_list}
            selectedDownloadList={selectedDownloadList}
            isDownloading={batchDownloadLoading}
            selectAll={_selectAll}
            deselectAll={_deselectAll}
            selectItem={_selectItem}
            onDownload={_download}
        />
    );
};

export default FJMultiSourceDownloadButtonContainer;
